<template>
    <div class="users">
        
        <div class="row mt-4">
            <div class="col-md-12">
                    <b-table :fields="fields" striped hover :items="customers">
                        <template v-slot:head(alldetails)="">
                            Actions
                        </template>
                        <template v-slot:head(showid)="">
                            #ID
                        </template>
                        <template v-slot:head(vesselname)="">
                            Company Name / Vessel
                        </template>
                        <template v-slot:head(showprices)="">
                            Price Visibility
                        </template>
                        <template v-slot:cell(showprices)="data">
                            <b-badge v-b-tooltip.hover title="Click to change status" style="cursor:pointer;" @click="enableprice(data.item)" :variant="data.item.showprices=='sale' || data.item.showprices=='sale & discount' ? 'success':'danger'">{{data.item.showprices==true ? data.item.showprices:data.item.showprices}}</b-badge>
                            <!-- <b-badge  small v-else :variant="danger">Enable Now</b-badge> -->

                        </template>
                        <template v-slot:cell(alldetails)="data">
                            <b-button variant="primary" size="sm" @click="showmodal(data.item)">View</b-button>
                        </template>
                    </b-table>

            </div>
        </div>

        <a-modal
            title="User Details"
            :visible="visible"
            :footer="null"
            @cancel="handlecancel"
            >
            
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Username</strong>: {{selecteduser.username}} </label>
                </div>
                <div class="col-md-6 col-12">
                    <label for="email"><strong>Email</strong>: {{selecteduser.email}}</label>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6 col-12">
                    <label for="role"><strong>Contact1</strong>: {{selecteduser.contact1}}</label>
                   
                </div>
                <div class="col-md-6 col-12">
                    <label for="password"><strong>Contact2</strong>: {{selecteduser.contact2}}</label>
                </div>
            </div>
             <div class="row mt-3">
                <div class="col-md-6 col-12">
                    <label for="role"><strong>Created</strong>: {{selecteduser.created}}</label>
                   
                </div>
                <div class="col-md-6 col-12">
                    <label for="password"><strong>Price View</strong>:  </label> <b-badge :variant="selecteduser.showprices=='sale' || selecteduser.showprices=='sale & discount' ? 'success':'danger'" >{{selecteduser.showprices==true ? selecteduser.showprices:selecteduser.showprices}}</b-badge>
                </div>
            </div>
             <div class="row mt-3">
                <div class="col-md-12 col-12">
                    <label for="role"><strong>Address</strong>: {{selecteduser.address}}</label>
                   
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-block" @click="handlecancel">Close</button>
                </div>
            </div>
        </a-modal>

       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: "Users",
    computed:{
        ...mapGetters(['customers'])
    },
    data() {
      return {
          fields:[
              'showid',
              'username',
              'email',
              'vesselname',
              'showprices',
              'address',
              'alldetails'

          ],
        selecteduser:'',
        visible: false,

       
      };
    },

    methods: {
      enableprice(item){
        //   console.log(item)
          let obj={...item}
          if(obj.showprices=='none'){
            obj.showprices='sale'          
          }
          else if(obj.showprices=='sale'){
            obj.showprices='sale & discount'          
          }
          else if(obj.showprices=='sale & discount'){
            obj.showprices='none'          
          }
          console.log(obj)
          
          this.$store.dispatch("updatePriceFlag",obj)


      },  
      showmodal(item) {
        this.selecteduser=item
        this.visible = true;
      },
      handlecancel(e) {
        this.visible = false;
      },
    
    }
}
</script>
